import moment from 'moment';
import 'moment/dist/locale/it';

export const refactorFormatDate = (
  date: string,
  format: string = 'DD/MM/yyyy',
) => {
  return moment.utc(date).local().format(format);
};
